import React from 'react'
import Collection from '../common/collection'

function CollectionJ({ props }) {
  return (
    <Collection
      alt="Interior Centro de Artes de Guanajuato"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg2.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg4.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg41.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg5.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg50.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg53.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg6.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg79.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/9.+interior+Cearg9.jpg',
      ]}
    />
  )
}


export default CollectionJ
